import React, { useEffect, useState } from "react"
import SearchInput from "../AddOrder/Components/SearchInput"
import LabSelectionDropbox from "../AddOrder/Components/LabSelectionDropbox"
import ProductsTable from "./Components/ProductsTable"
import AnimacionSuccessful from "../../AnimacionSuccessful/animacionSuccessful"
import { Button, Form, Pagination, Table, Modal } from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import OperationFinishedModal from "./Components/OperationFinishedModal"
import api from "../../../utils/axios";

export default function AddBiochemicalOrder() {
	const navigate = useNavigate()
	const [search, setSearch] = useState("")
	const [allProducts, setAllProducts] = useState([])
	const [selectedProducts, setSelectedProducts] = useState([])
	const [username, setUsername] = useState("")
	const [labsFromUser, setLabsFromUser] = useState([])
	const [userId, setUserId] = useState([])
	const [labSelected, setLabSelected] = useState()
	const [isAddOrdenButtonDisabled, setIsAddOrdenButtonDisabled] = useState(false)

	const [labProductsData, setLabProductsData] = useState(null)
	const [isLoadingLabProducts, setIsLoadingLabProducts] = useState(false)

	const [variable, setVariable] = useState(false)
	const [errorBool, setErrorBool] = useState(false)
	const [avisomsg, setAvisomsg] = useState("")

	const [productPageNumber, setProductPageNumber] = useState(0)
	const productsPerPage = 10
	const productsStartIndex = productPageNumber * productsPerPage
	const productsEndIndex = productsStartIndex + productsPerPage
	const productsPageCount = Math.ceil(allProducts.length / productsPerPage)
	const paginatedProducts = allProducts.slice(productsStartIndex, productsEndIndex)

	// Estado para el modal
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [isOperationFinishedModalOpen, setIsOperationFinishedModalOpen] = useState(false)

	// Almacena informacion de lotes que han sido editados o eliminados
	const [productsWithLotsEdited, setProductsWithLotsEdited] = useState([])

	useEffect(() => {
		; (async () => {
			try {
				const response = await api.get("/laboratory/my-order-labs");

				setUsername(response.data.username || "");
				setLabsFromUser(response.data.labs || []);
				setUserId(response.data.userId || "");
			} catch (error) {
				console.log("Error al obtener productos por laboratorio:", error);
			}
		})()
	}, [])

	useEffect(() => {
		if (!labSelected) {
			setLabProductsData(null)
			setAllProducts([])
			setIsLoadingLabProducts(false)
			return
		}

		; (async () => {
			try {
				setIsLoadingLabProducts(true)

				const response = await api.get(`/laboratory/${labSelected}/order-products`)
				setLabProductsData(response.data.lab || null)
			} catch (error) {
				console.log("Error al obtener productos del laboratorio:", error)
				setLabProductsData(null)
				setAllProducts([])
			} finally {
				setIsLoadingLabProducts(false)
			}
		})()
	}, [labSelected])

	useEffect(() => {
		; (async () => {
			if (!labSelected) {
				setAllProducts([]);
				return;
			}

			const labSelectedData = labProductsData;

			if (!labSelectedData) {
				setAllProducts([]);
				return;
			}

			const normalizedSearch = search.toUpperCase();

			const products = [
				...(labSelectedData.products || []),
				...(labSelectedData.tags || []).filter(tag => tag.isProducts),
			]
				.filter(product => {
					const matchesName = product.name?.toUpperCase().includes(normalizedSearch);

					const matchesChild =
						product.products?.some(p =>
							p.name?.toUpperCase().includes(normalizedSearch)
						) ||
						product.otherProducts?.some(p =>
							p.name?.toUpperCase().includes(normalizedSearch)
						);

					return matchesName || matchesChild;
				})
				.map(product => ({
					data: product,
					isTag: Array.isArray(product.products) || Array.isArray(product.otherProducts),
				}));

			setAllProducts(products);
		})()
	}, [labSelected, search, labProductsData])

	useEffect(() => {
		setProductPageNumber(0)
	}, [labSelected, search])

	const handleClick = async () => {
		try {
			setIsAddOrdenButtonDisabled(true)

			if (selectedProducts.some(product => product.data.quantity - product.quantityRequested < 0)) {

				setVariable(true)
				setErrorBool(true)
				setAvisomsg("Cantidad insuficiente de productos")
				setTimeout(() => {
					setVariable(false)
				}, 2000)

				setIsAddOrdenButtonDisabled(false)
				return
			}

			await api.post("/pedidos/add", {
				username: username,
				products: selectedProducts,
				labOrigin: labSelected,
				isFromBiochemicalRole: true,
			})
				.then(data => {
					; (async () => {
						const productsWithLotsEditedArray = []
						function addLot(product, lot, itWasDeleted, quantitySubtracted) {
							if (productsWithLotsEditedArray.some(prod => prod?.data?._id === product.data._id)) {
								productsWithLotsEditedArray.map(prod => {
									if (prod => prod.data._id === product.data._id) {
										const newProduct = prod
										if (itWasDeleted) {
											newProduct.lotsDeleted.push(lot)
											return newProduct
										} else {
											newProduct.lotsEdited.push({ ...lot, quantitySubtracted: quantitySubtracted })
											return newProduct
										}
									} else {
										return prod
									}
								})
							} else {
								if (itWasDeleted) {
									productsWithLotsEditedArray.push({
										data: { _id: product.data._id, name: product.data.name },
										lotsDeleted: [lot],
										lotsEdited: []
									})
								} else {
									productsWithLotsEditedArray.push({
										data: { _id: product.data._id, name: product.data.name },
										lotsEdited: [{ ...lot, quantitySubtracted: quantitySubtracted }],
										lotsDeleted: []
									})
								}
							}
						}
						for (const product of selectedProducts) {
							const productLots = [...(product.data.lots || [])].sort(
								(a, b) => new Date(a.expireDate) - new Date(b.expireDate)
							);

							if (!productLots.length) {
								setErrorBool(true);
								setVariable(true);
								setAvisomsg(`El producto ${product.data.name} no tiene lotes disponibles.`);
								setIsAddOrdenButtonDisabled(false);

								setTimeout(() => {
									setVariable(false);
								}, 3200);

								return;
							}
							let indice = 0
							do {
								if (product.quantityRequested >= productLots[indice].quantity) {
									product.quantityRequested -= productLots[indice].quantity
									addLot(product, productLots[indice], true)
									await api.put(`/lotes/edit/${productLots[indice]._id}`, {
										quantity: 0,
										product: product.data._id,
									})
									if (product.quantityRequested === 0) {
										break
									} else {
										indice++
									}
								} else {
									const updatedQuantity = productLots[indice].quantity - product.quantityRequested
									addLot(product, productLots[indice], false, product.quantityRequested)
									await api.put(`/lotes/edit/${productLots[indice]._id}`, {
										quantity: updatedQuantity,
										product: product.data._id,
									})
									product.quantityRequested = 0
								}
							} while (product.quantityRequested > 0 && indice < productLots.length)
						}
						setProductsWithLotsEdited(productsWithLotsEditedArray)
						setIsOperationFinishedModalOpen(true)
					})()



				})
				.catch(error => {
					// console.log(error)
					setErrorBool(true)
					setVariable(true)
					setAvisomsg(error.response.data.msg)
					setTimeout(() => {
						setVariable(false)
						setIsAddOrdenButtonDisabled(false)
					}, 3200)
				})
		} catch (error) {
			console.log(error)
		}
	}
	const handleFinalizarAutopedido = () => {
		setIsModalOpen(true) // Abre el modal
	}

	const handleModalConfirm = async () => {
		await handleClick() // Llama a la función para finalizar el autopedido
		setIsModalOpen(false) // Cierra el modal
	}

	const handleModalClose = () => {
		setIsModalOpen(false) // Cierra el modal
	}

	const handleAddOrRemoveItems = (item, quantity) => {
		const quantityNumber = Number(quantity)

		console.log("Producto seleccionado:", item)
		console.log("Cantidad ingresada:", quantityNumber)

		if (!item?.data?._id) {
			console.log("El producto no tiene data._id")
			return
		}

		if (selectedProducts.some(p => p?.data?._id === item?.data?._id)) {
			if (!quantityNumber || quantityNumber <= 0) {
				setSelectedProducts(prev =>
					prev.filter(p => p?.data?._id !== item?.data?._id)
				)

				return
			}

			setSelectedProducts(prev =>
				prev.map(product => {
					if (product?.data?._id === item?.data?._id) {
						return {
							...product,
							quantityRequested: quantityNumber,
						}
					}

					return product
				})
			)

			return
		}

		if (!quantityNumber || quantityNumber <= 0) return

		setSelectedProducts(prev => [
			...prev,
			{
				...item,
				quantityRequested: quantityNumber,
			},
		])
	}

	const handleLabSelectedChange = labId => {
		setLabSelected(labId)
		setLabProductsData(null)
		setIsLoadingLabProducts(Boolean(labId))
		setSelectedProducts([])
		setSearch("")
	}

	const handleProductsChangePage = selected => {
		setProductPageNumber(selected)
	}

	const getVisiblePaginationItems = () => {
		const totalPages = productsPageCount
		const currentPage = productPageNumber
		const delta = 1

		if (totalPages <= 7) {
			return Array.from({ length: totalPages }, (_, index) => index)
		}

		const pages = []

		pages.push(0)

		const start = Math.max(1, currentPage - delta)
		const end = Math.min(totalPages - 2, currentPage + delta)

		if (start > 1) {
			pages.push("left-ellipsis")
		}

		for (let i = start; i <= end; i++) {
			pages.push(i)
		}

		if (end < totalPages - 2) {
			pages.push("right-ellipsis")
		}

		pages.push(totalPages - 1)

		return pages
	}

	const handleFinishOperation = () => {
		setIsOperationFinishedModalOpen(false)
		setVariable(true)
		setErrorBool(false)
		setAvisomsg("Autopedido realizado con éxito!")
		setTimeout(() => {
			setVariable(false)
			navigate("/orders")
		}, 1200)
		setIsAddOrdenButtonDisabled(false)

	}

	return (
		<>
			<div className="main-container">
				<div className="header--container">
					<div className="order--header-cont">
						<div className="order--header-row">
							<h1 className="order--title">Carga autopedido de bioquímicos</h1>

						</div>
						<div className="order-row-select autopedido">
							<LabSelectionDropbox
								labSelected={labSelected}
								labsFromUser={labsFromUser}
								handleLabSelectedChange={handleLabSelectedChange}
							/>
							<SearchInput
								search={search}
								onChange={e => {
									setSearch(e.target.value)
									handleProductsChangePage(0)
								}}
							/>
						</div>
					</div>
				</div>
				<div className="card--container">
					<div className="table-container-new">
						<div className="table-striped table-bordered table-hover">
							{isLoadingLabProducts ? (
								<div style={{ textAlign: "center" }}>
									Cargando productos del laboratorio...
								</div>
							) : !labSelected ? (
								<div style={{ textAlign: "center" }}>
									Seleccione laboratorio.
								</div>
							) : allProducts.length > 0 ? (
								<ProductsTable
									orderItems={paginatedProducts}
									selectedProducts={selectedProducts}
									handleAddOrRemoveItems={handleAddOrRemoveItems}
								/>
							) : (
								<div style={{ textAlign: "center" }}>
									No hay productos bioquímicos asignados a este laboratorio.
								</div>
							)}
						</div>
					</div>

					{/* Paginación */}
					{/* Paginación */}
					{paginatedProducts.length > 0 && productsPageCount > 1 && (
						<div className="pagination-order pagination-all-tag">
							<Pagination>
								<Pagination.Prev
									onClick={() =>
										handleProductsChangePage(
											productPageNumber > 0 ? productPageNumber - 1 : 0
										)
									}
									disabled={productPageNumber === 0}
								/>

								{getVisiblePaginationItems().map(item => {
									if (typeof item === "string") {
										return (
											<Pagination.Ellipsis
												key={item}
												disabled
											/>
										)
									}

									return (
										<Pagination.Item
											className="pagination-item"
											key={item}
											active={item === productPageNumber}
											onClick={() => handleProductsChangePage(item)}
										>
											{item + 1}
										</Pagination.Item>
									)
								})}

								<Pagination.Next
									onClick={() =>
										handleProductsChangePage(
											productPageNumber < productsPageCount - 1
												? productPageNumber + 1
												: productsPageCount - 1
										)
									}
									disabled={productPageNumber === productsPageCount - 1}
								/>
							</Pagination>
						</div>
					)}

					{/* Botones */}
					<div className="content-card-order">
						<Button
							className="btn-auto-order"
							children="Finalizar autopedido"
							onClick={handleFinalizarAutopedido}
							disabled={isAddOrdenButtonDisabled || !labSelected || !selectedProducts.length}
						/>
					</div>
				</div>
			</div>
			{/* Modal de confirmación */}
			<div >
				<Modal
					show={isModalOpen}
					onHide={handleModalClose}
				>
					<Modal.Header closeButton>
						<Modal.Title className="title-auto-order">Confirmar Autopedido</Modal.Title>
					</Modal.Header>
					<Modal.Body className="text-auto-order">
						<p>Usted va a realizar el siguiente pedido:</p>
						<ul>
							{selectedProducts.map(product => {
								return (
									<li key={product.data._id}>
										{product.data.name} - Cantidad: {product.quantityRequested}
									</li>
								)
							})}
						</ul>
					</Modal.Body>
					<Modal.Footer >
						<Button
							className="btn-auto-modal-text"
							onClick={handleModalClose}
						>
							Rechazar
						</Button>
						<Button
							className="btn-auto-modal"
							onClick={handleModalConfirm}
						>
							Aceptar
						</Button>
					</Modal.Footer>
				</Modal>
			</div>
			{isOperationFinishedModalOpen && (

				<OperationFinishedModal productsWithLotsEdited={productsWithLotsEdited} handleFinishOperation={handleFinishOperation} />
			)}

			{/* Modal de estado */}
			{variable && (
				<AnimacionSuccessful
					errorBool={errorBool}
					avisomsg={avisomsg}
				/>
			)}
		</>
	)
}
